import { Trans } from '@lingui/react/macro';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@repo/videa-components/src/index';

import type { ZuubTreatmentHistory } from '@/@types/zuub/contracts';
import { useLocalizedFormatDate } from '@/modules/claims/summary/state';

interface TreatmentHistoryTableProps {
  data: ZuubTreatmentHistory[];
}

export const TreatmentHistoryTable = ({ data }: TreatmentHistoryTableProps) => {
  const formatDate = useLocalizedFormatDate();

  if (data.length === 0) {
    return (
      <div className="vai-text-center vai-text-gray-500 vai-py-8">
        <Trans>No treatment history data available.</Trans>
      </div>
    );
  }

  return (
    <div className="vai-w-full vai-overflow-hidden">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="vai-text-left vai-font-medium vai-text-muted-foreground vai-text-sm vai-uppercase">
              <Trans>ADA CODE</Trans>
            </TableHead>
            <TableHead className="vai-text-left vai-font-medium vai-text-muted-foreground vai-text-sm vai-uppercase">
              <Trans>PROCEDURE</Trans>
            </TableHead>
            <TableHead className="vai-text-center vai-font-medium vai-text-muted-foreground vai-text-sm vai-uppercase">
              <Trans>TOOTH/QUAD</Trans>
            </TableHead>
            <TableHead className="vai-text-center vai-font-medium vai-text-muted-foreground vai-text-sm vai-uppercase">
              <Trans>SURFACE</Trans>
            </TableHead>
            <TableHead className="vai-text-center vai-font-medium vai-text-muted-foreground vai-text-sm vai-uppercase">
              <Trans>DATE</Trans>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((item, index) => (
            <TableRow key={`${item.adaCode}-${item.date}-${index}`}>
              <TableCell className="vai-text-sm vai-text-foreground">
                {item.adaCode}
              </TableCell>
              <TableCell className="vai-text-sm vai-text-foreground">
                {item.procedure}
              </TableCell>
              <TableCell className="vai-text-sm vai-text-foreground vai-text-center">
                {item.toothQuad || ''}
              </TableCell>
              <TableCell className="vai-text-sm vai-text-foreground vai-text-center">
                {item.surface || ''}
              </TableCell>
              <TableCell className="vai-text-sm vai-text-foreground vai-text-center">
                {formatDate(item.date)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
